import { EffectiveServicePriceModel, ServiceLocationModel } from "../../data/entities";
import { ServiceLocationODataRepo, ServiceLocationRepo } from "../../data/repo";
import { BaseEntityService } from "../BaseEntityService"

export class ServiceLocationService extends BaseEntityService<ServiceLocationModel, ServiceLocationRepo, ServiceLocationODataRepo> {
  constructor(){
    super(new ServiceLocationRepo(), new ServiceLocationODataRepo());
  }

  async addServiceToLocation(locationId: number, serviceTypeId: number): Promise<boolean> {
    return await this.repo.addServiceToLocation(locationId, serviceTypeId);
  } 
  
  async getByServiceAndLocationAsync(serviceId: number, locationId: number | string): Promise<ServiceLocationModel[]> {
    return await this.repo.getByServiceAndLocationAsync(serviceId, locationId);
  }

  async getEffectiveServicePriceAsync(serviceId: number, locationId: number): Promise<EffectiveServicePriceModel>{
    return await this.repo.getEffectiveServicePriceAsync(serviceId, locationId);
  }
}

export default ServiceLocationService;
